import { Component, OnInit } from '@angular/core';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { ICalendarizacion, IListaAnhos, IListaPeriodos, IListaSecciones } from 'src/app/interfaces/ponderaciones';
import { IActa } from 'src/app/interfaces/portal-calificaciones';
import { IAperturaSecciones, IBodyApertura, ICierreSecciones, IEstados, ILista, IListaMasiva, IListaMasivaRes, IListaRes, IListadoErrSap, IResDetalleErrSap, IResListaErroresSap } from 'src/app/interfaces/secciones';
import { MantenedorSeccionesService } from 'src/app/services/mantenedor-secciones/mantenedor-secciones.service';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';

@Component({
  selector: 'app-view-mantenedor-secciones',
  templateUrl: './view-mantenedor-secciones.component.html',
  styleUrls: ['./view-mantenedor-secciones.component.scss']
})
export class ViewMantenedorSeccionesComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  dtOptions3: DataTables.Settings = { ...DatatableConfig.simpledt };

  filtroAnhos:  Array<number> = [];
  filtroPeriodos: Array<any> = [];
  filtroSedes: Array<any> = [];
  filtroSecciones: Array<any> = [];
  filtroEstados: Array<any> = [];

  filtroPeriodoSeleccionado: number = 0;
  filtroAnyoSeleccionado: number = 0;
  filtroSedeSeleccionado: number = 0;
  filtroSeccionSeleccionado: number = 0;
  filtroEstadoSeleccionado: number = 0;

  listaSecciones: ILista[] = [];
  listaMasiva: IListaMasiva[] = [];

  renderTableGestion: boolean = true;
  renderTableMasiva: boolean = true;
  renderTableReenvioSap: boolean = true;
  procesoMasivoSinTerminar: boolean = false;

  submitted: boolean = false;

  tieneErrores: any = {};
  error: string = "";
  mensajeExito: string = "";

  user: any;

  seccionesSeleccionadas: number = 0;

  mostrarCheckbox: string = "";

  funcionIntervalo: any;
  funcionIntervaloMasivo: any = "";
  seccionEnProceso: boolean = false;
  procesosMasivos: boolean = false;
  fechaVigente: boolean = false;

  seleccionarTodosReenvioSap: boolean = false
  listaReenvioSap: Array<IListadoErrSap> = []
  detalleErrSapModal: any = {}

  arrSeccionesModificadas: ILista[] = []

  constructor(private _secciones: MantenedorSeccionesService,
    private _perfilamiento: PerfilamientoService,
    private _portalServices: PortalCalificacionesService,
    private _calendarizacion: PonderacionesService
  ) {}
  
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      lengthMenu: [10, 20, 30, 40, 50],
      processing: true,
      searching: false,
      scrollX: true,
      autoWidth: false,
      ordering:  false, // nuevo
      dom: "<'pull-left's>t<'bottom'>lp",
      "drawCallback": function (settings) {
        $('.bottom').css("margin-top", "1%");
        $(".paginate_button").css("background", "none").css("border-radius", "4px").css("padding", "0.3em 0.7em").css("font-size","1.4rem").css("opacity","1 !important");
        $(".paginate_button").hover(function () {
          $(this).css('cssText', 'color: black !important; background: none; border-radius: 4px; padding: 0.3em 0.7em; font-size:1.4rem')
        });
      },
      language: DatatableConfig.spanish_datatables,
      columnDefs: [{
        "targets": "0",
        "width": "5%"
      },
      {"targets": [0], "searchable": false, "orderable": false}]
    };
    this.dtOptions2 = {...this.dtOptions}
    this.dtOptions3 = {...this.dtOptions}
    this.getAnyos();
    this.getEstados();
    this.user = this._perfilamiento.getUsuario();
    this.actualizarTabla();
  }
  
  seleccionFiltro(filtro: string): void {
    switch (filtro) {
      case "anho":
        this.limpiarFiltros("anyo");
        this.tieneErrores["anyo"] = false;
        this.getPeriodos();
        break;
      case "periodo":
        this.limpiarFiltros("periodo");
        this.tieneErrores["periodo"] = false;
        this.getSedes(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado);
        break;
      case "sede":
        this.limpiarFiltros("sede");
        this.tieneErrores["sede"] = false;
        this.getSecciones(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado,this.filtroSedeSeleccionado);
        break;
      case "seccion":
        
        break;
      case "estado":

        break;
      default:
        break;
    }
  }
  limpiarFiltros(filtro: string): void {
    switch(filtro) {
      case "anyo":
        this.filtroSedeSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroSeccionSeleccionado = 0;
        this.filtroEstadoSeleccionado = 0;

        this.filtroPeriodos = [];
        this.filtroSedes = [];
        this.filtroSecciones = [];
        break;
      case "periodo":
        this.filtroSedeSeleccionado = 0;
        this.filtroSeccionSeleccionado = 0;
        this.filtroEstadoSeleccionado = 0;

        this.filtroSedes = [];
        this.filtroSecciones = [];
        break;
      case "sede":
        this.filtroSeccionSeleccionado = 0;
        this.filtroEstadoSeleccionado = 0;

        this.filtroSecciones = [];
        break;
      default:
        this.filtroAnyoSeleccionado = 0;
        this.filtroSedeSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroSeccionSeleccionado = 0;
        this.filtroEstadoSeleccionado = 0;

        this.filtroPeriodos = [];
        this.filtroSedes = [];
        this.filtroSecciones = [];
        this.submitted = false;
        this.tieneErrores["anyo"] = false;
        this.tieneErrores["periodo"] = false;
        this.tieneErrores["sede"] = false;
        this.renderTableGestion = false
        this.renderTableMasiva = false;
        break;
    }
  }

  getAnyos(): void {
    this._secciones.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnhos = res.anyos
      }, (err: any) => {
      }
    )
  }
  getEstados(): void {
    this._secciones.getEstados().subscribe(
      (res: IEstados) => {
        this.filtroEstados = res.estados;
      }
    )
  }
  getPeriodos(): void {
    if(this.filtroAnyoSeleccionado != 0) {
      this._secciones.getFiltrosPeriodos(this.filtroAnyoSeleccionado).subscribe(
        (res: IListaPeriodos) => {
          this.filtroPeriodos = res.periodos;
        }
      )
    }
  }
  getSedes(anyo: number, periodoId: number): void {
    if (anyo != 0 && periodoId != 0) {
      let user = this._perfilamiento.getUsuario();
      this._secciones.getFiltrosSedes(user.usuarioId).subscribe(
        (res: any) => {
          this.filtroSedes = res.sedes;
        }
      )
    }
  }
  getSecciones(anyo: number, periodoId: number, sedeId: number): void {
    if (anyo != 0 && periodoId != 0 && sedeId != 0) {
      this._secciones.getFiltrosSecciones(anyo, periodoId, sedeId).subscribe(
        (res: IListaSecciones) => {
          this.filtroSecciones = res.secciones;
        }
      )
    }
  }

  busqueda(): void {
    this.submitted = true;
    this.mostrarCheckbox = "";
    this.seccionesSeleccionadas = 0;
    let errores = false;
    this.arrSeccionesModificadas = []
    if(this.filtroAnyoSeleccionado == 0){
      this.tieneErrores["anyo"] = true;
      this.tieneErrores["periodo"] = true;
      this.tieneErrores["sede"] = true;
      errores = true;
    }
    if(this.filtroPeriodoSeleccionado == 0){
      this.tieneErrores["periodo"] = true;
      this.tieneErrores["sede"] = true;
      errores = true;
    }
    if(this.filtroSedeSeleccionado == 0){
      this.tieneErrores["sede"] = true;
      errores = true;
    }
    if(!errores) {
      this._calendarizacion.getCalendarizacion(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado,"SECCIONES_MASIVAS").subscribe({
        next:(res: ICalendarizacion) => {
          if(res.modificable) {
            this.fechaVigente = true;
          } else {
            this.fechaVigente = false;
          }
        }
      });
      this.procesosMasivos = true;
      this.obtenerListaMasiva()
      this.procesosMasivos = false;
      this.buscarLista()
      this.obtenerListaErroresSap()
    }
  }

  fnIntervalListaGestionSecciones(): void {
    this.funcionIntervalo = setInterval(() =>{
      if (document.visibilityState === 'visible' && this.seccionEnProceso) {
        this.buscarLista();
      }
    }, (1000 * 60));
  }

  actualizarTabla(): void {
    this.fnIntervalListaGestionSecciones()
    this.funcionIntervaloMasivo = setInterval(() => {
      if (document.visibilityState === 'visible' && this.procesoMasivoSinTerminar) {
        this.procesosMasivos = true;
        this.obtenerListaMasiva();
        this.procesosMasivos = false;
      }
    },60000)
  }

  ngOnDestroy(): void {
    clearInterval(this.funcionIntervalo);
    clearInterval(this.funcionIntervaloMasivo);
  }

  reiniciarDt(idTabla: string, dtOptions: any): void {
    const $tabla = $(`#${idTabla}`);
    if ($.fn.dataTable.isDataTable($tabla)) {
      $(`#${idTabla}`).DataTable().destroy();
    }
    setTimeout(() => {
      if (!$.fn.dataTable.isDataTable($tabla)) {
        $(`#${idTabla}`).DataTable(dtOptions);
      }
    }, 350); 
  }

  buscarLista(): void {
    let body = {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      sedeId: this.filtroSedeSeleccionado,
      seccionId: this.filtroSeccionSeleccionado,
      estadoId: this.filtroEstadoSeleccionado
    }
    if ( this.renderTableGestion ) {
      this.renderTableGestion = false;
      this.reiniciarDt('tabla-gestion', this.dtOptions3)
    }
    this.renderTableGestion = true;
    this.seccionEnProceso = false;
    
    this.dtOptions3.serverSide = true
    this.dtOptions3.pageLength = 10
    this.dtOptions3.processing = true
    this.dtOptions3.ajax = (dataTablesParameters: any, callback) => {
      let paramsTableBody = {
        pageSize: dataTablesParameters.length,
        pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
      }

      this._secciones.getLista(body, paramsTableBody.pageSize, paramsTableBody.pageNumber).subscribe(
        (res: IListaRes) => {
          this.listaSecciones = res.listado;
          this.listaSecciones.forEach(seccion => {
            seccion.checked = false;
            if (seccion.estado == "P") {
              this.seccionEnProceso = true;
            }
          })
          callback({
            recordsTotal: res.totalItems,
            recordsFiltered: res.totalItems,
            data:[]
          })
          setTimeout(() => {
            $("#tabla-gestion").DataTable().columns.adjust();
          }, 180);

          if ( this.listaSecciones.length > 0 ) {
            setTimeout(() => {
              const emptyElement = document.querySelector('#tabla-gestion_wrapper .dataTables_empty');
              emptyElement?.setAttribute('style', 'display: none');
            }, 350);
          }
        }
      )
    }
  }

  reajustarTabla(curr?: string): void {
    setTimeout(() => {
      $("#tabla-procesos-masivos").DataTable().columns.adjust();
      $("#tabla-gestion").DataTable().columns.adjust();
      $("#tabla-reenvio-sap").DataTable().columns.adjust();
    }, 280);
    
  }

  descargarActa(estado: string, seccionId: number): void {
    if (estado == "C") {
      this._portalServices.descargarActa(seccionId, this.filtroAnyoSeleccionado, this.filtroPeriodoSeleccionado).subscribe({
        next: (res: IActa) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.saveAsPdfFile(res.archivo, res.nombreArchivo);
          }
        },
        error: error => {
          this.limpiarError();
        }
      })
    }
  }
  limpiarError(): void {
    setTimeout(() => {
      this.error = "";
      this.mensajeExito = ""
    }, 6000);
  }
  saveAsPdfFile ( base64: string | null, nombreArchivo: string | null ) {
    const mediaType="data:application/pdf;base64,"
    const file = base64
    let a = document.createElement('a')
    a.href = mediaType+file
    a.download = nombreArchivo+'.pdf'
    a.click()
  }

  calcularSeleccionadas(seccion: any, evento: any): void {
    clearInterval(this.funcionIntervalo)
    const index = this.arrSeccionesModificadas.findIndex(seccionModificada => seccion.idSeccion === seccionModificada.idSeccion)
    if ( evento.target.checked && index === -1 ) {
      this.arrSeccionesModificadas.push(seccion)
    }
    if ( !evento.target.checked ) {
      this.arrSeccionesModificadas.splice(index, 1); // Eliminar el objeto
    }

    if (evento.target.checked) {
      if (seccion.estado == "A") {
        this.mostrarCheckbox = "A";
      } else if (seccion.estado == "C") {
        this.mostrarCheckbox = "C";
      } else if (seccion.estado == "P") {
        this.mostrarCheckbox = "";
      }
    }
    if (this.arrSeccionesModificadas.length == 0) {
      this.mostrarCheckbox = "";
      this.fnIntervalListaGestionSecciones()
    }
    if (this.arrSeccionesModificadas.length > 1) {
      this.procesosMasivos = true;
    } else {
      this.procesosMasivos = false;
    }

    this.seccionesSeleccionadas = this.arrSeccionesModificadas.length;
  }

  seccionChecked(seccion: any): boolean {
    return this.arrSeccionesModificadas.some(s => s.idSeccion === seccion.idSeccion)
  }

  seleccionarTodos(evento: any): void {
    let contador = 0;
    this.listaSecciones.forEach((seccion: any, index: number) => {
      if (seccion.estado == this.mostrarCheckbox) {
        seccion.checked = evento.target.checked;
        if(seccion.checked) {
          contador++;
        }
      }
    })
    if(contador == 0) {
      this.mostrarCheckbox = "";
    }
    if (contador > 1) {
      this.procesosMasivos = true;
    } else {
      this.procesosMasivos = false;
    }

    this.seccionesSeleccionadas = contador;
  }

  confirmarAccion(): void {
    let body: IBodyApertura;
    let listaAsignaturasTmp: Array<number> = [];
    let listaAsignaturas: Array<number> = [];
    let listaSeccionesArr: Array<number> = [];

    this.arrSeccionesModificadas.forEach((seccion: any) => {
      listaAsignaturasTmp.push(seccion.asignaturaId);
      listaSeccionesArr.push(seccion.idSeccion);
    })
    listaAsignaturas = listaAsignaturasTmp.filter((asignatura,index)=>{
      return listaAsignaturasTmp.indexOf(asignatura) === index;
    })
    body = {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      sedeId: this.filtroSedeSeleccionado,
      asignaturaIdLista: listaAsignaturas,
      seccionIdLista: listaSeccionesArr
    }
    if (this.mostrarCheckbox == "A") {
      this._secciones.postCierreSecciones(body).subscribe({
        next: (res: ICierreSecciones) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.seccionesSeleccionadas = 0;
            setTimeout(() => {
              this.busqueda()
              this.fnIntervalListaGestionSecciones()
            }, 2000);
          }
        }
      })
    }
    if(this.mostrarCheckbox == "C") {
      this._secciones.postAperturaSecciones(body).subscribe({
        next:(res:IAperturaSecciones) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.seccionesSeleccionadas = 0;
            setTimeout(() => {
              this.busqueda();
              
            }, 2000);
          }
        }
      })
    }
    
  }

  obtenerListaMasiva(): void {
    this.procesoMasivoSinTerminar = false;
    if(this.procesosMasivos) {
      if ( this.renderTableMasiva ) {
        this.renderTableMasiva = false;
        this.reiniciarDt('tabla-procesos-masivos', this.dtOptions2)
      }
      this.renderTableMasiva = true;

      // Datatable serverside
      this.dtOptions2.serverSide = true
      this.dtOptions2.pageLength = 10
      this.dtOptions2.processing = true
      this.dtOptions2.ajax = (dataTablesParameters: any, callback) => {
        let paramsTableBody = {
          pageSize: dataTablesParameters.length,
          pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
        }

        this._secciones.getListaMasiva(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado,this.filtroSedeSeleccionado, paramsTableBody.pageSize, paramsTableBody.pageNumber).subscribe({
          next: (res: IListaMasivaRes) => {
            this.listaMasiva = res.listado;
            this.listaMasiva.forEach(proceso => {
              let estado = proceso.estado.split(" ");
              if (estado[0] != estado[2]) {
                this.procesoMasivoSinTerminar = true;
              }
            })
            callback({
              recordsTotal: res.totalItems,
              recordsFiltered: res.totalItems,
              data:[]
            })
            if ( this.listaMasiva.length > 0 ) {
              setTimeout(() => {
                const emptyElement = document.querySelector('#tabla-procesos-masivos_wrapper .dataTables_empty');
                emptyElement?.setAttribute('style', 'display: none');
              }, 350);
            }
          }
        })
      }
      // Fin Datatable serverside
    }
  }
  validarVisualizacionCheckbox(seccion: any): boolean {

    //solo se muestran si el año y periodo esta vigente.
    if(!this.fechaVigente) {
      return false;
    } 
    
    if (this.fechaVigente && seccion.estado != 'P') {
      //se muestran solo los checkbox del estado seleccionado
      if (this.mostrarCheckbox == seccion.estado){
        return true;
      }
      //se muestran todos los checkbox ya que no se ha seleccionado ninguno
      if (this.mostrarCheckbox == '') {
        return true;
      }
    }


    return false;
  }

  obtenerListaErroresSap(): void {
    if ( this.renderTableReenvioSap ) {
      this.renderTableReenvioSap = false;
      this.reiniciarDt('tabla-reenvio-sap', this.dtOptions)
    }
    this.renderTableReenvioSap = true;
    // Datatable serverside
    this.dtOptions.serverSide = true
    this.dtOptions.pageLength = 10
    this.dtOptions.processing = true
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      let paramsTableBody = {
        pageSize: dataTablesParameters.length,
        pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
      }

      this._secciones.obtenerListaErroresSap(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado,this.filtroSedeSeleccionado, this.filtroSeccionSeleccionado, paramsTableBody.pageSize, paramsTableBody.pageNumber).subscribe(
        (res: IResListaErroresSap) => {
          this.listaReenvioSap = res.listado
          this.listaReenvioSap.forEach((err: any) => { err.checked = false })
          callback({
            recordsTotal: res.totalItems,
            recordsFiltered: res.totalItems,
            data:[]
          })
          setTimeout(() => {
            $("#tabla-reenvio-sap").DataTable().columns.adjust();
          }, 180);
          if ( this.listaReenvioSap.length > 0 ) {
            setTimeout(() => {
              const emptyElement = document.querySelector('#tabla-reenvio-sap_wrapper .dataTables_empty');
              emptyElement?.setAttribute('style', 'display: none');
            }, 350);
          }
        }
      )
    }
    // Fin Datatable serverside
  }

  seleccionarTodoReenvioSap(event: any): void {
    this.listaReenvioSap.forEach((err: any) => {
      err.checked = event.target.checked
    })
  }

  seleccionErrorSap(error: any, event: any): void {
    error.checked = event.target.checked
  }

  reenvioSapDisponible(): boolean {
    const listaReenvioChecked = this.listaReenvioSap.filter((err: any) => err.checked)
    return listaReenvioChecked.length > 0
  }

  reenviarListaSap(): void {
    let seccionesSeleccionadasArr: Array<number> = []
    this.listaReenvioSap.forEach(
      (err: IListadoErrSap) => {
        if ( err.checked ) {
          seccionesSeleccionadasArr.push(err.seccionEvaluacionId)
        }
      }
    )
    let body = {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      sedeId: this.filtroSedeSeleccionado,
      seccionEvaluacionIdLista: seccionesSeleccionadasArr
    }
    this._secciones.postReintentoCierreSecciones(body).subscribe(
      (res: ICierreSecciones) => {
        if ( res.valor ) {
          this.mensajeExito = 'Reenvio a SAP con exito'
          this.obtenerListaErroresSap()
        } else {
          this.error = res?.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios'
        }
        this.limpiarError()
      }
    )
  }

  obtenerDetalleErrorSap(seccionEvaluacionId: number): void {
    this.detalleErrSapModal = {}
    this._secciones.obtenerDetalleErrorSap(seccionEvaluacionId).subscribe(
      (res: IResDetalleErrSap) => {
        this.detalleErrSapModal = res
        document.getElementById('modal-detalle-err-sap-btn')?.click()
      }
    )
  }
}
